var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playlist"},[_c('PlaylistCard',{attrs:{"playlist":_vm.playlist,"isOpen":_vm.isOpen},on:{"openContent":_vm.openContent}}),(_vm.isOpen)?_c('PlaylistContent',{attrs:{"playlistId":_vm.playlist.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }